export enum Tool {
  pointer = 'pointer',
  database = 'database',
  calculation = 'calculation',
  split = 'split',
  aggregation = 'aggregation',
  view = 'view',
}
